import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Panel from 'react-bootstrap/lib/Panel'
import SearchIcon from 'react-icons/lib/md/search'

import SearchStudent from 'containers/Students/search-student'
import { fetchFees } from 'containers/Fees/actions'

class Billing extends Component {

  constructor(props) {
    super(props)
    this.state = {
      openSearch: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.studentID !== this.props.params.studentID) {
      this.setState({
        openSearch: false,
      })
    }
  }

  _openSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _closeSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  render() {
    const { openSearch } = this.state
    const { children, __session } = this.props

    const header = (
      <div className="row">
        <div className="col-sm-6">
          <span>Billing Assessment <strong className="text-info">{__session.get('sy')} - {__session.get('sem')}</strong></span>
        </div>
        <div className="col-sm-6 text-right">
          <button type="button" onClick={this._openSearch} className="btn-icon btn-inline"><SearchIcon /></button>
        </div>
      </div>
    )
    return (
      <Panel header={header}>
        { React.cloneElement(children, { openSearch: this._openSearch }) }
        <SearchStudent
          linkBase="/billing"
          handleClose={this._closeSearch}
          isOpen={openSearch}
        />
      </Panel>
    )
  }
}

Billing.onEnter = (store) => () => store.dispatch(fetchFees())

Billing.propTypes = {
  __session: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __session: state.auth.get('session'),
  }
}

export default connect(mapStateToProps)(Billing)



// WEBPACK FOOTER //
// ./src/containers/Billing/index.js